// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'avenir', 'avenir Fallback'"},"className":"__className_793e70"};